<template>
  <div>
    <vx-card>
      <div class="vx-row flex-1">
        <div class="vx-col flex-1">
          <div class="flex-1" v-if="viewLoginInfo">
            <vx-card :title="$t('LoginInfo')" class="mt-base" no-shadow card-border>
              <div class="vx-col lg:center w-full">
                <div class="flex-1">
                  <vs-input :label="$t('UsernameRequired')" v-model="traineeModel.Username" class="mt-5 w-full"
                    name="Username" v-validate="'required'" />
                  <span class="text-warning text-sm">{{ $t('ValidEmail') }}</span>
                  <br />
                  <span class="text-danger text-sm" v-show="errors.has('Username')">{{ errors.first('Username') }}</span>
                </div>
                <div class="flex-1 ">
                  <password :model="traineeModel" />
                </div>
              </div>
            </vx-card>
          </div>

          <div class="flex-1">
            <vx-card :title="$t('MainInfo')" class="mt-base" no-shadow card-border>
              <div class="vx-col lg:center w-full">
                <div class="flex-1">
                  <p>{{ $t('Title') }} * </p>
                  <v-select label="Name" v-model="traineeModel.UserTitleID" :options="UserTitles" autocomplete
                    class="w-full" :reduce="value => value.ID" v-validate="'required'" />
                  <span class="text-danger text-sm" v-show="errors.has('Title')">{{ errors.first('Title') }}</span>
                </div>
                <div class="">
                  <div class="vx-row ml-1">
                    <vs-input :label="$t('FirstName')" v-model="traineeModel.FirstName" class="mt-5 vx-col lg:w-1/3"
                      name="name" v-validate="'required'" />
                    <vs-input :label="$t('MiddleName')" v-model="traineeModel.MiddleName" class="mt-5  vx-col lg:w-1/3"
                      name="name" v-validate="'required'" />
                    <vs-input :label="$t('LastName')" v-model="traineeModel.LastName" class="mt-5 vx-col lg:w-1/3"
                      name="name" v-validate="'required'" />
                  </div>
                  <span class="text-warning text-sm">{{ $t('ThisNameWillUseInCertificate') }}</span>
                  <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                </div>
                <div class="flex-1">
                  <vs-input :label="$t('JobTitleRequied')" v-model="traineeModel.JobTitle" class="mt-5 w-full"
                    name="JobTitle" v-validate="'required'" />
                  <span class="text-danger text-sm" v-show="errors.has('JobTitle')">{{ errors.first('JobTitle') }}</span>
                </div>
                <div class="flex-1">
                  <vs-input :label="$t('OrganizationName')" v-model="traineeModel.OrganizationName" class="mt-5 w-full"
                    name="OrganizationName" v-validate="'required'" />
                  <span class="text-danger text-sm" v-show="errors.has('OrganizationName')">{{
                    errors.first('OrganizationName') }}</span>
                </div>

                <div class="flex-1">
                  <vs-input :label="$t('SuperviserEMail')" v-model="traineeModel.SuperviserMail" class="mt-5 w-full"
                    name="SuperviserMail" v-validate="'required'" />
                  <span class="text-danger text-sm" v-show="errors.has('SuperviserMail')">{{
                    errors.first('SuperviserMail') }}</span>
                </div>
                <div class="flex-1">
                  <vs-input :label="$t('Section')" v-model="traineeModel.Section" class="mt-5 w-full" name="Section" />

                </div>
              </div>
            </vx-card>
          </div>


          <div class="flex-1">
            <vx-card :title="$t('AdressInfo')" class="mt-base" no-shadow card-border>
              <div class="vx-col w-full">
                <div class="flex-1">
                  <vs-input :label="$t('Address1')" v-model="traineeModel.Address1" class="mt-5 w-full" name="Address1"
                    v-validate="'required'" />
                  <span class="text-danger text-sm" v-show="errors.has('Address1')">{{ errors.first('Address1') }}</span>
                </div>
                <div class="flex-1">
                  <vs-input :label="$t('Address2')" v-model="traineeModel.Address2" class="mt-5 w-full" name="Address2" />
                  <span class="text-danger text-sm" v-show="errors.has('Address2')">{{ errors.first('Address2') }}</span>
                </div>
                <div class="flex-1">
                  <vs-input :label="$t('City')" v-model="traineeModel.City" class="mt-5 w-full" name="City"
                    v-validate="'required'" />
                  <span class="text-danger text-sm" v-show="errors.has('City')">{{ errors.first('City') }}</span>
                </div>
                <div class="flex-1">
                  <vs-input :label="$t('ZipCode')" v-model="traineeModel.ZipCode" class="mt-5 w-full" name="ZipCode" />
                  <span class="text-danger text-sm" v-show="errors.has('ZipCode')">{{ errors.first('ZipCode') }}</span>
                </div>
              </div>
            </vx-card>
          </div>


        </div>
        <div class="vx-col flex-1">
          <div class="flex-1">
            <vs-card style="margin-top:25px" no-shadow card-border>
              <h4>{{ $t('ProfileImage') }}</h4>
              <template>

                <!-- Image Container -->
                <div class="img-container w-64 mx-auto flex items-center justify-center" style="min-height:200px">
                  <img :src="DownUrl + AttachmentUrl" alt="img" class="responsive" v-if="AttachmentUrl">
                </div>
              </template>
              <!-- Image upload Buttons -->
              <div class="modify-img flex justify-between mt-5">
                <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
                <vs-button class="mr-4" type="flat"
                  @click="$refs.updateImgInput.click()">{{ $t('UpdateAttachment') }}</vs-button>
                <vs-button type="flat" color="#999"
                  @click="AttachmentUrl = null; traineeModel.ImageProfilePath = null">{{ $t('RemoveAttachment') }}</vs-button>
              </div>
            </vs-card>
            <vx-card :title="$t('PersonalInfo')" class="mt-base" no-shadow card-border>
              <div class="vx-col w-full">
                <div class="flex-1 mt-5 ">
                  <p>{{ $t('NationalityRequired') }}</p>
                  <v-select label="Name" v-model="traineeModel.NationalityID" :options="nationalities" autocomplete
                    class="w-full" :reduce="value => value.ID" />

                  <span class="text-danger text-sm" v-show="errors.has('Nationality')">{{ errors.first('Nationality')
                  }}</span>
                </div>
                <div class="flex-1 mt-5 ">
                  <p>{{ $t('Country') }} *</p>
                  <v-select label="Name" v-model="traineeModel.CountryID" :options="countries" class="w-full" autocomplete
                    :reduce="value => value.ID" />

                  <span class="text-danger text-sm" v-show="errors.has('Country')">{{ errors.first('Country') }}</span>
                </div>
                <div class="flex-1">
                  <vs-input :label="$t('PassportNo')" v-model="traineeModel.PassportNo" class="mt-5 w-full"
                    name="PassportNo" v-validate="'required'" />
                  <span class="text-danger text-sm" v-show="errors.has('PassportNo')">{{ errors.first('PassportNo')
                  }}</span>
                </div>


                <div class="flex-1 mt-5">

                  <label>{{ $t('Birthdate') }}</label>
                  <datepicker name="BirthDate" format="yyyy-MM-dd" v-model="traineeModel.BirthDate"
                    v-bind:v-validate="{ required: true, date_format: 'YYYY-MM-DD' }"></datepicker>
                  <span class="text-danger text-sm" v-show="errors.has('BirthDate')">{{ errors.first('BirthDate')
                  }}</span>
                </div>
                <div class="flex-1 mt-5 ">
                  <p>{{ $t('MaritalStatus') }}</p>
                  <v-select label="Name" class="w-full" v-model="traineeModel.MaritalStatusID" :options="maritalStatuses"
                    :reduce="value => value.ID" />

                  <span class="text-danger text-sm" v-show="errors.has('MaritalStatus')">{{ errors.first('MaritalStatus')
                  }}</span>
                </div>

                <div class="mt-5">
                  <label for="Status" class="vs-input--label mr-5">{{ $t('Gender') }} *</label>
                  <vs-radio v-model="traineeModel.Gender" vs-name="radios1" vs-value="Male">{{ $t('Male') }}</vs-radio>
                  <vs-radio v-model="traineeModel.Gender" vs-name="radios1" class="ml-10" vs-value="Female">
                    {{ $t('FeMale') }}</vs-radio>
                </div>
              </div>
            </vx-card>
          </div>

          <div class="vx-col w-full">
            <vx-card :title="$t('JobInfo')" class="mt-base" no-shadow card-border>
              <div class="vx-col w-full">
                <div class="flex-1 mt-5 ">
                  <p>{{ $t('IndustrySector') }}*</p>
                  <v-select label="Name" class="w-full" v-model="traineeModel.IndustrySectorID" :options="industrySectors"
                    :reduce="value => value.ID" />

                  <span class="text-danger text-sm" v-show="errors.has('IndustrySector')">{{
                    errors.first('IndustrySector') }}</span>
                </div>
                <div class="flex-1 mt-5">
                  <p>{{ $t('PreferredLanguage') }}</p>
                  <v-select label="Name" class="w-full" v-model="traineeModel.PreferredLanguageID" :options="languages"
                    autocomplete :reduce="value => value.ID" />
                  <span class="text-danger text-sm" v-show="errors.has('Language')">{{ errors.first('Language') }}</span>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </div>
    </vx-card>
    <vs-prompt :title="$t('NewContact')" :accept-text="$t('Save')" :cancel-text="$t('Cancel')" @cancel="clearContactModal"
      @accept="SaveContact" @close="clearContactModal" :is-valid="validateContactForm" :active.sync="activePrompt">
      <VuePerfectScrollbar style="height: 372px!important" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
        <form @submit.prevent style="max-height:75vh">
          <p>{{ $t('ContactType') }}</p>
          <v-select label="Name" v-model="contact.ContactTypeID" :options="contactTypes" class="mt-5 w-full" autocomplete
            :reduce="value => value.ID" />
          <vs-input class="w-full mt-4" :label="$t('ContactText')" v-model="contact.ContactText" name="ContactText" />
          <span class="text-danger text-sm" v-show="errors.has('ContactText')">{{ errors.first('ContactText') }}</span>
        </form>
      </VuePerfectScrollbar>
    </vs-prompt>

    <vs-prompt :title="$t('NewAttachment')" :accept-text="$t('Save')" :cancel-text="$t('Cancel')"
      @cancel="clearAttachmentModal" @accept="SaveAttachment" @close="clearAttachmentModal"
      :is-valid="validateAttachmentForm" :active.sync="activePromptAttachment">
      <VuePerfectScrollbar class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
        <form @submit.prevent style="max-height:75vh">
          <div class="mt-5 vx-row w-full " style="padding-left:20px">
            <div class=" lg:w-3/4" style="padding-left:20px">
              <vs-input :label="$t('DescriptionOfAttachment')" v-model="attachment.DescriptionOfAttachment"
                class="mt-5 w-full" name="DescriptionOfAttachment" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('DescriptionOfAttachment')">{{
                errors.first('DescriptionOfAttachment') }}</span>
            </div>
            <div class="vx-col">
              <label class="vs-input--label">file</label>
              <!-- {{CourseQuestionBank.AttachedPicURL}} -->
              <vs-upload automatic :limit="1" :action="uploadUrl" :headers="UploadRequestHeader"
                @on-success="successUpload" />
            </div>
          </div>

        </form>
      </VuePerfectScrollbar>
    </vs-prompt>

    <div class="vx-row mt-5">
      <div class="vx-col lg:w-1/2 w-full" v-if="viewLoginInfo">
        <vx-card :title="$t('Contact')">
          <div class="flex-1">
            <vs-input :label="$t('WorkEmail')" v-model="traineeModel.Contacts.workmail" class="mt-5 w-full"
              name="workmail" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('workmail')">{{ errors.first('workmail') }}</span>
          </div>

          <div class="flex-1">
            <vs-input :label="$t('Mobile')" v-model="traineeModel.Contacts.Mobile" class="mt-5 w-full" name="Mobile" />
            <span class="text-danger text-sm" v-show="errors.has('Mobile')">{{ errors.first('Mobile') }}</span>
          </div>

          <div class="flex-1">
            <vs-input :label="$t('PersonalMail')" v-model="traineeModel.Contacts.Email" class="mt-5 w-full" name="Email"
              v-validate="'email'" />
            <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
          </div>

          <div class="text-warning text-danger"
            v-if="traineeModel.PreferredMail == 1 && getListOfTraineeContact.findIndex(obj => obj.ContactTypeID == 5) == -1">
            {{ $t('PleasAddWorkMail') }}</div>

          <div class="flex-1 mt-5">
            <span class="text-sm">{{ $t('PreferdEmail') }} </span>
            <vs-radio v-model="traineeModel.PreferredMail" vs-name="radios1" vs-value="1">{{ $t('WorkEmail') }}</vs-radio>
            <vs-radio v-model="traineeModel.PreferredMail" vs-name="radios1" class="ml-10" vs-value="2">
              {{ $t('PersonalMail') }}</vs-radio>
            <!-- <div class="text-warning text-danger" > mail that use to send you</div>  -->
          </div>
        </vx-card>
      </div>
      <div class="vx-col lg:w-1/2 w-full" v-if="!viewLoginInfo">
        <vx-card :title="$t('Contact')">
          <vs-button type="border" class="mb-4 mt-4" icon-pack="feather" icon="icon-plus"
            @click="activePrompt = true">{{ $t('AddContact') }} </vs-button>
          <vs-table ref="table" pagination :max-items="5" :data="getListOfTraineeContact">
            <template slot="thead">
              <vs-th>{{ $t('ContactType') }}</vs-th>
              <vs-th>{{ $t('ContactText') }}</vs-th>
              <vs-th>{{ $t('Action') }}</vs-th>
            </template>

            <template slot-scope="{data}">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <p class="product-name font-medium truncate">{{ tr.ContactType.Name }}</p>
                  </vs-td>
                  <vs-td>
                    <p class="product-name font-medium truncate">{{ tr.ContactText }}</p>
                  </vs-td>
                  <vs-td class="whitespace-no-wrap">
                    <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      @click.stop="editContact(tr)" />
                    <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                      @click="openConfirm(tr)" />
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
          <div class="text-warning text-danger"
            v-if="traineeModel.PreferredMail == 1 && getListOfTraineeContact.findIndex(obj => obj.ContactTypeID == 5) == -1">
            {{ $t('PleasAddWorkMail') }}</div>
          <div class="flex-1 mt-5">
            <span class="text-sm">{{ $t('PreferdEmail') }} </span>
            <vs-radio v-model="traineeModel.PreferredMail" vs-name="radios1" vs-value="1"> {{ $t('WorkEmail') }}</vs-radio>
            <vs-radio v-model="traineeModel.PreferredMail" vs-name="radios1" class="ml-10"
              vs-value="2">{{ $t('PersonalMail') }}</vs-radio>
            <!-- <div class="text-warning text-danger" > mail that use to send you</div>  -->

          </div>
        </vx-card>

      </div>
      <div v-if="!viewLoginInfo" class="vx-col lg:w-1/2 w-full">
        <vx-card :title="$t('Attachment')">

          <span class="text-warning ">{{ $t('UploadCvs') }}</span>
          <vs-button type="border" class="mb-4 mt-4" icon-pack="feather" icon="icon-plus"
            @click="activePromptAttachment = true">{{ $t('AddAttachment') }} </vs-button>

          <vs-table ref="table" pagination :max-items="5" :data="getListOfTraineeAttachment">
            <template slot="thead">
              <vs-th>{{ $t('AttachmentDescription') }}</vs-th>
              <vs-th>{{ $t('Download') }}</vs-th>
              <vs-th>{{ $t('Action') }}</vs-th>
            </template>

            <template slot-scope="{data}">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <p class="product-name font-medium truncate">{{ tr.DescriptionOfAttachment }}</p>
                  </vs-td>
                  <vs-td>
                    <a :href="DownUrl + tr.UrlAttachment" download target="_blank"><feather-icon icon="DownloadIcon"
                        svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" /></a>

                  </vs-td>
                  <vs-td class="whitespace-no-wrap">
                    <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                      @click="openConfirmAttachment(tr)" />
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
    <add-edit-education class="mt-4" :trainingModel="traineeModel" v-if="!viewLoginInfo" />
  </div>
</template>
<script>
import AddEditEducation from "./Add-Edit-Education.vue"
import moduleTrainee from "@/store/user/trainee/moduleTrainee.js";
import moduleLanguage from "@/store/settings/language/moduleLanguage.js";
import moduleContactType from "@/store/settings/contactType/moduleContactType.js";
import moduleNationality from "@/store/settings/nationality/moduleNationality.js";
import moduleIndustrySector from "@/store/settings/industrySector/moduleIndustrySector.js";
import moduleMaritalStatus from "@/store/settings/maritalStatus/moduleMaritalStatus.js";
import Datepicker from 'vuejs-datepicker';
import { domain, mainSetting } from '@/gloabelConstant.js'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import modulecountry from "@/store/settings/country/moduleCountry.js";
import moduleUserTitle from "@/store/settings/userTitle/moduleUserTitle.js";
import vSelect from 'vue-select'
import axios from "@/axios.js"
import password from "../../views/components/password.vue";

export default {
  components: {
    password,
    Datepicker,
    VuePerfectScrollbar,
    vSelect,
    AddEditEducation
  },
  props: {
    traineeModel: {
      type: Object,
      default: () => { }
    },
    viewLoginInfo: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      passwordType: "password",
      AttachmentUrl: null,
      UploadRequestHeader: mainSetting.UploadRequestHeader,
      DownUrl: domain,
      uploadUrl: domain + "API/Course/UploadFile",
      selected: [],
      activePrompt: false,
      activePromptAttachment: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30,
      },
      dataForDeleted: {},
      edit: false,
      listOfTraineeContact: [],
      listOfTraineeAttachment: [],
      // ListOfContactTypes:[],
      itemsPerPage: 10,
      isMounted: false,
      contact: {},
      contacts: {},

      rowDataForDelete: {},
      activeConfirm: false,

      attachment: {},

    };
  },
  computed: {
    UserTitles() {
      return this.$store.state.UserTitleList.UserTitles;
    },
    countries() {
      return this.$store.state.countryList.countries;
    },
    validateAttachmentForm() {
      return this.attachment.DescriptionOfAttachment != undefined;
    },
    getListOfTraineeAttachment() {
      return this.traineeModel.Attachments;
    },
    validateContactForm() {
      return this.contact.ContactTypeID != undefined && this.contact.ContactText != undefined;
    },
    isFormValid() {
      return !this.errors.any() && this.traineeModel.FullName;
    },
    validateForm() {
      return !this.errors.any()
    },
    getListOfTraineeContact() {

      return this.traineeModel.TraineeContacts
    },
    languages() {
      return this.$store.state.languageList.languages;
    },
    nationalities() {
      return this.$store.state.nationalityList.nationalities;
    },
    industrySectors() {
      return this.$store.state.industrySectorList.industrySectors;
    },

    contactTypes() {
      return this.$store.state.contactTypeList.contactTypes;
    },
    maritalStatuses() {
      return this.$store.state.maritalStatusList.maritalStatuses;
    },
  },
  methods: {
    showPassword() {
      if (this.passwordType == 'text')
        this.passwordType = 'password'
      else
        this.passwordType = 'text'
    },
    updateCurrImg(input) {
      debugger
      if (input.target.files && input.target.files[0]) {
        let data = new FormData()
        data.append('file', input.target.files[0])
        debugger
        axios.post(this.uploadUrl, data)
          .then((response) => {
            this.traineeModel.ImageProfilePath = response.data;
            this.AttachmentUrl = response.data;
          })
      }
    },
    openConfirmAttachment(data) {
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Confirm")
        ,
        text: this.$t("Areyousureyouwantdeletethisrecord") + "?",
        accept: this.acceptAlertAttachment
      });
    },
    acceptAlertAttachment() {

      this.deleteAttachment(this.rowDataForDelete);
      this.$vs.notify({
        time: 8000,
        color: "danger",
        title: this.$t("Deletedrecord"),
        text: this.$t("Theselectedrecordwassuccessfullydeleted")
      });
    },
    deleteAttachment(data) {

      if (data.ID > 0) {
        this.$store.dispatch("traineeList/removeAttachment", data.ID);
      }

      const ItemIndex = this.traineeModel.Attachments.findIndex((p) => p.DescriptionOfAttachment == data.DescriptionOfAttachment)
      //if(ItemIndex!=-1)
      this.traineeModel.Attachments.splice(ItemIndex, 1)
    },
    SaveAttachment() {
      //this.listOfTraineeAttachment.push(this.attachment);
      if (!this.traineeModel.Attachments)
        this.traineeModel.Attachments = [];
      this.traineeModel.Attachments.push(this.attachment);

      this.clearAttachmentModal();

    },

    clearAttachmentModal() {
      this.attachment = {}
    },

    successUpload(event) {

      this.attachment.UrlAttachment = event.target.responseText;
      this.$vs.notify({
        time: 8000, color: 'success',
        title: this.$t("UploadSuccess"),
        text: this.$t("SuccessuploadyourAttachment")
      })
    },

    initValues() {
      this.traineeModel = {
        TraineeContacts: [],
        TraineeExamAnswers: [],
      };

    },

    SaveContact() {

      const isExist = this.traineeModel.TraineeContacts.findIndex((p) => p.ContactTypeID == this.contact.ContactTypeID);
      if (isExist >= 0) {
        if (this.edit) {
          if (this.dataForDeleted.ContactType.ID != this.contact.ContactType.ID) {
            this.$vs.dialog({
              color: "warning",
              title: this.$t("Dialogwarning"),
              text: this.$t("ThisContactAlreadyExists"),
            })
            this.contact = {};
            return;
          }
        }
        // this.colorAlert = color
        else {
          this.$vs.dialog({
            color: "warning",
            title: this.$t("Dialogwarning"),
            text: this.$t("ThisContactAlreadyExists"),


          })
          this.contact = {};
          return;
        }
      }
      if (this.edit) {
        this.deleteContact(this.dataForDeleted);
        this.edit = false;
      }
      this.contact.ContactType = this.contactTypes.find((p) => p.ID == this.contact.ContactTypeID);

      // this.listOfTraineeContact.push(this.contact);
      //this.traineeModel.TraineeContacts=this.listOfTraineeContact;
      this.traineeModel.TraineeContacts.push(this.contact);
      this.clearContactModal();
    },

    clearContactModal() {
      this.contact = {}
    },



    openConfirm(data) {

      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Confirm"),
        text: this.$t("Areyousureyouwantdeletethisrecord") + "?",
        accept: this.acceptAlert
      });
    },
    acceptAlert() {

      this.deleteContact(this.rowDataForDelete);
      this.$vs.notify({
        time: 8000,
        color: "danger",
        title: this.$t("Deletedrecord"),
        text: this.$t("Theselectedrecordwassuccessfullydeleted")
      });
    },
    notifyAlert(color, title, text) {
      this.$vs.notify({
        time: 8000,
        color: color,
        title: title,
        text: text
      });
    },
    deleteContact(data) {

      if (data.ID > 0) {
        this.$store.dispatch("traineeList/removeContact", data);
      }

      const ItemIndex = this.traineeModel.TraineeContacts.findIndex((p) => p.ContactTypeID == data.ContactTypeID)
      //if(ItemIndex!=-1)
      this.traineeModel.TraineeContacts.splice(ItemIndex, 1)
    },
    editContact(data) {
      this.edit = true;
      this.contact = JSON.parse(JSON.stringify(data));
      this.dataForDeleted = JSON.parse(JSON.stringify(data));
      this.activePrompt = true;
    },


  },

  created() {
    if (!moduleUserTitle.isRegistered) {
      this.$store.registerModule("UserTitleList", moduleUserTitle);
      moduleUserTitle.isRegistered = true;
    }
    this.$store.dispatch("UserTitleList/fetchDataListItems");
    if (!moduleTrainee.isRegistered) {
      this.$store.registerModule("traineeList", moduleTrainee);
      moduleTrainee.isRegistered = true;
    }
    if (!moduleLanguage.isRegistered) {
      this.$store.registerModule("languageList", moduleLanguage);
      moduleLanguage.isRegistered = true;
    }
    if (!moduleIndustrySector.isRegistered) {
      this.$store.registerModule("industrySectorList", moduleIndustrySector);
      moduleIndustrySector.isRegistered = true;
    }
    if (!moduleNationality.isRegistered) {
      this.$store.registerModule("nationalityList", moduleNationality);
      moduleNationality.isRegistered = true;
    }
    if (!moduleContactType.isRegistered) {
      this.$store.registerModule("contactTypeList", moduleContactType);
      moduleContactType.isRegistered = true;
    }
    if (!moduleMaritalStatus.isRegistered) {
      this.$store.registerModule("maritalStatusList", moduleMaritalStatus);
      moduleMaritalStatus.isRegistered = true;
    }
    if (!modulecountry.isRegistered) {
      this.$store.registerModule("countryList", modulecountry);
      modulecountry.isRegistered = true;
    }
    this.$store.dispatch("traineeList/GetLoginTrainee").then(res => {

      this.AttachmentUrl = res.data.ImageProfilePath;
    })
    this.$store.dispatch("countryList/fetchDataListItems");
    this.$store.dispatch("languageList/fetchDataListItems");
    this.$store.dispatch("contactTypeList/fetchDataListItems");
    this.$store.dispatch("nationalityList/fetchDataListItems");
    this.$store.dispatch("industrySectorList/fetchDataListItems");
    this.$store.dispatch("maritalStatusList/fetchDataListItems");

  },
  mounted() {
    this.isMounted = true;
  }
}
</script>
